module.exports = __webpack_public_path__ + "static/media/zaha park shot 1.866ff874.webp";